import axios from 'axios';

export default {
  FETCH_FUNNIES ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('common/getAllFunnies')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('funnies', JSON.stringify(payload));
                    commit('SET_FUNNIES', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDFUNNY ({ commit }, funnyId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`common/getAllFunnies`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedFunny = payload.filter(x => {
              return x.funnyId.toString() === funnyId.toString()
            });

            console.log('found funny', selectedFunny)
            commit('SET_SELECTED_FUNNY', selectedFunny[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_FUNNY({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
          payload.csvCorporationId = payload.csvCorporationId.toString()
            commit('TOGGLE_LOADING', true);
            console.log("add funny payload : ", payload);
            axios.post('common/insertFunnies', payload)
                .then((response) => {
                    console.log('ADD_FUNNY action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_FUNNY action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_FUNNY({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
          payload.csvCorporationId = payload.csvCorporationId.toString()
            commit('TOGGLE_LOADING', true);
            axios.put('/common/updateFunnies', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_FUNNY action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/funnies/actions.js